module.exports = __webpack_public_path__ + "img/traits_4@2x.079b0367.png";